import { Box, styled } from '@mui/material';

import { COLORS } from '../../../../../configs/colors';

export const HeroWrapper = styled(Box)`
  position: relative;
  z-index: 10;
  margin-top: -46px;
  padding: 0 16px;
  margin-bottom: 12px;
`;

export const HeroContainer = styled(Box)`
  background: ${COLORS.White};
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 18px;
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const RadialTimerContainer = styled(Box)`
  position: relative;
  width: 110px;
  height: 110px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TimerSvg = styled('svg')`
  transform: rotate(-90deg);
`;

export const TimerContent = styled(Box)`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const TimeRemaining = styled(Box)`
  font-weight: 700;
  font-size: 1.4rem;
  line-height: 1;
  letter-spacing: -0.5px;
`;

export const TimeLabel = styled(Box)`
  font-weight: 500;
  font-size: 0.6rem;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: ${COLORS.MediumGrey};
  margin-top: 1px;
`;

export const SLABreakdown = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const SLARow = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SLARowLabel = styled(Box)`
  font-weight: 500;
  font-size: 0.7rem;
  color: ${COLORS.MediumGrey};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const SLARowValue = styled(Box)`
  font-weight: 600;
  font-size: 0.82rem;
  color: ${COLORS.Black};
`;

export const SLABar = styled(Box)`
  height: 5px;
  background: #eef2f6;
  border-radius: 3px;
  overflow: hidden;
`;

export const SLABarFill = styled(Box)`
  height: 100%;
  border-radius: 3px;
  background: linear-gradient(135deg, ${COLORS.NavyBlue} 0%, ${COLORS.NavyBlueDark} 100%);
`;
